import React from "react";
import "bootstrap/dist/css/bootstrap.min.css"; // Make sure Bootstrap is imported
import isGHMC from "../../Common/helper/helpar";

const VehicleFilter = ({
  filter,
  handleFilterChange,
  handleSearch,
  handleReset,
  zones,
  circles,
  collectionTypes,
  vehicleTypes,
  ownerTypes,
  loading,
}) => {
  const isProd = isGHMC();

  return (
    <div className="container-fluid">
      <div className="row align-items-center bg-light p-3 rounded">
        {/* Vehicle Number Field */}
        <div className="col-md-3 mb-3">
          <input
            type="text"
            className="form-control"
            placeholder="Vehicle Number"
            value={filter.vehicleNumber || ""}
            onChange={(e) =>
              handleFilterChange("vehicleNumber", e.target.value)
            }
          />
        </div>

        {/* Zone Filter */}
        <div className="col-md-3 mb-3">
          <select
            className="form-select"
            value={filter.zoneId || ""}
            onChange={(e) => handleFilterChange("zoneId", e.target.value)}
          >
            <option value="">Select Zone</option>
            {zones
              .filter((zone) => zone.isActive)
              .map((zone) => (
                <option key={zone.zoneId} value={zone.zoneId}>
                  {zone.zoneName}
                </option>
              ))}
          </select>
        </div>

        {/* Circle Filter */}
        <div className="col-md-3 mb-3">
          <select
            className="form-select"
            value={filter.circleId || ""}
            onChange={(e) => handleFilterChange("circleId", e.target.value)}
          >
            <option value="">Select Circle</option>
            {circles
              .filter((circle) => circle.isActive)
              .map((circle) => (
                <option key={circle.circleId} value={circle.circleId}>
                  {circle.circleName}
                </option>
              ))}
          </select>
        </div>

        {/* Collection Type Filter */}
        <div className="col-md-3 mb-3">
          <select
            className="form-select"
            value={filter.collectionTypeId || ""}
            onChange={(e) =>
              handleFilterChange("collectionTypeId", e.target.value)
            }
          >
            <option value="">Select Collection Type</option>
            {collectionTypes.map((collectionType) => (
              <option
                key={collectionType.collectionTypeId}
                value={collectionType.collectionTypeId}
              >
                {collectionType.collectionTypeName}
              </option>
            ))}
          </select>
        </div>

        {/* Vehicle Type Filter */}
        <div className="col-md-3 mb-3">
          <select
            className="form-select"
            value={filter.vehicleTypeId || ""}
            onChange={(e) =>
              handleFilterChange("vehicleTypeId", e.target.value)
            }
          >
            <option value="">Select Vehicle Type</option>
            {vehicleTypes
              .filter((vehicleType) => vehicleType.isActive)
              .map((vehicleType) => (
                <option
                  key={vehicleType.vehicleTypeId}
                  value={vehicleType.vehicleTypeId}
                >
                  {vehicleType.vehicleTypeName}
                </option>
              ))}
          </select>
        </div>
        {filter.collectionTypeId == 1 ?
          < div className="col-md-3 mb-3">
        <input
          type="text"
          className="form-control"
          placeholder="SFA Incharge Name/Number"
          value={filter.searchText || ""}
          onChange={(e) =>
            handleFilterChange("searchText", e.target.value)
          }
        />
      </div>
        :''}

      {/* Search Button */}
      <div className="col-md-2 mb-3">
        <button
          onClick={handleSearch}
          disabled={loading}
          className={`btn w-100 ${isProd ? "search-ghmc" : "search-swm"}`}
        >
          {loading ? "Searching..." : "Search"}
        </button>
      </div>

      {/* Reset Button */}
      <div className="col-md-2 mb-3">
        <button
          onClick={handleReset}
          disabled={loading}
          className={`btn w-100 ${isProd ? "search-ghmc" : "search-swm"}`}
        >
          Reset
        </button>
      </div>
    </div>
    </div >
  );
};

export default VehicleFilter;